export const CHANGE_LIST_DATA = "contacts/CHANGE_LIST_DATA";
export const SET_CONTACT_INFO = "contacts/SET_CONTACT_INFO";
export const SET_ALL_ENTITY_OPTION = "contacts/SET_ALL_ENTITY_OPTION";
export const SELECTED_INFO = "contacts/SELECTED_INFO";
export const RESET_STAGE = "contacts/RESET_STAGE";
export const SET_DETAIL_CONTACT_INFO = "contacts/SET_DETAIL_CONTACT_INFO";
export const SET_DATA = "contacts/SET_DATA";
